import React from 'react';
import { default as OriginalUploadThumb } from '../../../../../MediaPopup/_partials/UploadThumb';
const UploadThumb = ({ fileUploadInfo })=>{
    if (!fileUploadInfo) {
        return null;
    }
    const { file, progress, error } = fileUploadInfo;
    return /*#__PURE__*/ React.createElement(OriginalUploadThumb, {
        file: file,
        progress: progress,
        error: error
    });
};
export default UploadThumb;

//# sourceMappingURL=UploadThumb.js.map